var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yuan"},[_c('div',{staticClass:"yuan_right"},[_c('div',{staticClass:"one"}),_c('div',{staticClass:"two"})])])}]

export { render, staticRenderFns }